import { z } from "zod";

export const indicateSchema = z.object({
  name: z.string().min(3, "Nome deve ter pelo menos 3 caracteres"),
  cpf: z.string().min(11, "CPF deve ter pelo menos 11 caracteres").regex(/^[0-9.-\\-\\]+$/, "CPF não pode conter letras nem espaços."),
  phone: z.string().min(11, "Telefone deve ter pelo menos 11 caracteres").regex(/^[0-9-\\(\\)\\-\\]+$/, "Telefone não pode conter letras nem espaços."),
  produto: z.string().min(1, "Produto deve ser selecionado"),
});

export type IndicateFormValues = z.infer<typeof indicateSchema>;